import { spawnTrackingEventListners } from '../../../../assets/scripts/components/tracking-ga-events'
import cookieConsent from 'services/cookies-consent'

function init(): void {
  // set GA/GTM events tracking
  spawnTrackingEventListners()

  // cookiebot banner
  cookieConsent.init()
}

init()
